import React from "react";
import { List, ListItem, ListItemText, CircularProgress, Typography } from "@mui/material";
import axios from "axios";
import { useAuthState } from "../../Context";
import { useQuery } from "@tanstack/react-query";
import BlankPage from '../BlankPage/BlankPage';

const fetchDashboards = async (token) => {
  const apiUrl = `${process.env.REACT_APP_BACKEND_URL}/getDashboards`;
  const response = await axios.get(apiUrl, {
    headers: {
      authorizationToken: token,
    },
  });
  if (response.status !== 200) {
    throw new Error("Failed to fetch dashboards");
  }
  return response.data;
};

const DashboardManagement = () => {
//   const { session } = useAuthState();
//   const token = session.getIdToken().getJwtToken();

//   const { data: dashboards, isLoading, isError, error } = useQuery({
//     queryKey: ["DashboardsData", token],
//     queryFn: () => fetchDashboards(token),
//     refetchOnWindowFocus: false,
//   });

//   if (isLoading) {
//     return <CircularProgress />;
//   }

//   if (isError) {
//     return (
//       <Typography variant="h6" sx={{ textAlign: "center" }}>
//         Error: {error.message}
//       </Typography>
//     );
//   }

  return (
    // <List>
    //   {dashboards.map((dashboard) => (
    //     <ListItem key={dashboard.id}>
    //       <ListItemText primary={dashboard.title} />
    //     </ListItem>
    //   ))}
    // </List>
    <BlankPage/>
  );
};

export default DashboardManagement;
